export default "__VITE_ASSET__qMNVchtO__"